export default "__VITE_ASSET__WOCCcFkT__"